import { StoreConnectors } from './generic-layer'
import { NeuroglancerManagedUserLayer } from '../neuroglancer-type-mappings'
import { distinctUntilChanged, map, Observable, startWith, take } from 'rxjs'
import { TrackableService } from '../../../case-viewer/neuroglancer-frame/trackable.service'
import { LayerType } from './layer-types'

export class BaseLayer {
    get name(): string | undefined {
        return this.baseLayer.name
    }

    get nameOrDefault(): string {
        return this.baseLayer.name
    }

    get source(): string | undefined {
        return (this.baseLayer.layer?.dataSources.length ?? 0) > 0
            ? this.baseLayer.layer?.dataSources[0].spec.url
            : undefined
    }

    visible$: Observable<boolean>
    private getVisible(): boolean {
        return this.baseLayer.visible
    }
    setVisible(value: boolean): void {
        if (this.getVisible() === value) return
        this.baseLayer.setVisible(value)
        this.storeConnectors.dispatchVisible?.(this.name, value)
    }
    toggleVisible(): void {
        const value = !this.getVisible()
        this.setVisible(value)
        if (value) {
            ;(this as any).shaderColor?.value$.pipe(take(1)).subscribe((l: any) => {
                this.storeConnectors.dispatchShaderColor?.(this.name, l)
            })
        }
    }

    readonly hoverLabel$: Observable<string | null>

    protected constructor(
        private readonly baseLayer: NeuroglancerManagedUserLayer,
        private readonly storeConnectors: StoreConnectors,
        trackable: TrackableService
    ) {
        this.visible$ = trackable.observeEvent(this.baseLayer.layerChanged).pipe(
            startWith(this.baseLayer.visible),
            map(() => this.baseLayer.visible),
            distinctUntilChanged()
        )

        this.hoverLabel$ = trackable
            .observeEvent(this.baseLayer.manager.layerSelectedValues.changed)
            .pipe(
                map(() => {
                    const userLayer = this.baseLayer.layer
                    if (!userLayer) return null

                    if (userLayer.type === LayerType.Annotation) return null

                    const values = this.baseLayer.manager.layerSelectedValues.get(userLayer)
                    if (values == null || values.value == null) return null

                    const valueStr = values.value.toString()
                    return valueStr === '0' ? null : valueStr
                }),
                distinctUntilChanged()
            )
    }
}
